jQuery(document).ready(function ($) {
    $("#side-menu").mmenu({
        offCanvas: {
            moveBackground: false,
            zposition: 'front'
        },
        "extensions": [
            "border-full",
            "fx-panels-slide-100",
            "pagedim-black",
            "shadow-page",
            "shadow-panels"
        ],
        "iconPanels": {
            'add': true
        },
        "searchfield": {
            add: true,
            "addTo": 'panels'
        },
        navbar: {
            add: true
        }
    }, {
        offCanvas: {
            menuInsertSelector: '#page-wrapper',
            pageSelector: '#page-content'
        },
        "searchfield": {
            "clear": true
        }
    });

    var menu_api = $('#side-menu').data('mmenu');

    if (typeof menu_api !== 'undefined') {
        menu_api.bind("open:start", function () {
            $('.side-mini-panel').animate({"left": "-60px"}, "fast").removeClass('visible');
        });
        menu_api.bind("close:before", function () {
            menu_api.closeAllPanels();
            $('.side-mini-panel').animate({"left": "0"}, "fast").addClass('visible');
        });
    }


    $('.menu-trigger').on('click', function () {
        var menu = $('#' + $(this).attr('data-menu'));
        var panel = $(menu.parent().find('a').attr('href'));
        if (!$('#side-menu').hasClass('mm-opened')) {
            menu_api.open();
            menu_api.openPanel(panel);
        } else {
            menu_api.close();
        }
    });
});